import { CascadiaJsonFormContext } from "@certn/forms";
import { ArrayControlProps } from "@jsonforms/core";
import { withJsonFormsArrayControlProps } from "@jsonforms/react";
import { useContext } from "react";

import { CredentialHistoryControl } from "./CredentialHistoryControl";
import { CredentialHistorySummaryControl } from "./CredentialHistorySummaryControl";

function InternalCredentialHistoryControl(props: ArrayControlProps) {
  const { isSummary } = useContext(CascadiaJsonFormContext);

  if (isSummary) {
    return <CredentialHistorySummaryControl {...props} />;
  }

  return <CredentialHistoryControl {...props} />;
}

export const CredentialHistoryControlRenderer = withJsonFormsArrayControlProps(
  InternalCredentialHistoryControl
);
